@if (!selectedTemplateId) {
  <div class="row g-2 align-items-center mb-3">
    <div class="col-12 col-lg input-trend-search">
      <input
        type="search"
        class="form-control"
        [formControl]="searchControl"
        [placeholder]="'waTemplate.select.searchPlaceholder' | translate"
        [attr.aria-label]="'waTemplate.select.searchPlaceholder' | translate"
        (input)="filterTemplates($event)"
      />
      <span class="mdi mdi-magnify search-icon"></span>
    </div>

    <div class="col-12 col-lg-auto d-flex flex-wrap gap-2">
      <button
        type="button"
        class="btn btn-primary dropdown-toggle"
        [matMenuTriggerFor]="statusMenu"
      >
        <i class="mdi mdi-filter-variant me-1" aria-hidden="true"></i>
        <span>{{
          selectedStatus
            ? translateTemplateStatus(selectedStatus)
            : ("waTemplate.select.status" | translate)
        }}</span>
      </button>
      <mat-menu #statusMenu="matMenu">
        <button mat-menu-item (click)="filterByStatus('')">
          {{ "waTemplate.select.all" | translate }}
        </button>
        @for (status of statuses; track status.value) {
          <button mat-menu-item (click)="filterByStatus(status.value)">
            {{ status.label }}
          </button>
        }
      </mat-menu>

      <button
        type="button"
        class="btn btn-primary dropdown-toggle"
        [matMenuTriggerFor]="categoryMenu"
      >
        <i class="mdi mdi-filter-variant me-1" aria-hidden="true"></i>
        <span>{{
          selectedCategory
            ? translateTemplateCategory(selectedCategory)
            : ("waTemplate.select.category" | translate)
        }}</span>
      </button>
      <mat-menu #categoryMenu="matMenu">
        <button mat-menu-item (click)="filterByCategory('')">
          {{ "waTemplate.select.all" | translate }}
        </button>
        @for (category of categories; track category.value) {
          <button mat-menu-item (click)="filterByCategory(category.value)">
            {{ category.label }}
          </button>
        }
      </mat-menu>

      <button
        type="button"
        class="btn btn-primary"
        (click)="cleanCacheTemplates()"
      >
        <i class="mdi mdi-refresh me-1" aria-hidden="true"></i>
        {{ "waTemplate.select.refresh" | translate }}
      </button>
    </div>
  </div>
} @else {
  <div class="mb-3">
    <button
      type="button"
      class="btn btn-sm btn-primary"
      (click)="clearTemplate()"
    >
      <i class="mdi mdi-swap-horizontal me-1" aria-hidden="true"></i>
      {{ "waTemplate.select.changeTemplate" | translate }}
    </button>
  </div>
}

@if (loading) {
  <!-- `spinner-border` do tema em vez de `mat-spinner`, e num `div` em vez de
       um `li` solto sem lista em volta. -->
  <div class="d-flex flex-column align-items-center gap-2 py-4">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">{{
        "waTemplate.select.loadingTemplates" | translate
      }}</span>
    </div>
    <p class="text-muted mb-0">
      {{ "waTemplate.select.loadingTemplates" | translate }}
    </p>
  </div>
} @else if (loadingContent) {
  <content-loading-list />
} @else if (templates.length === 0) {
  <empty-records-component
    [message]="'waTemplate.select.noTemplatesFound' | translate"
    [subMessage]="'waTemplate.select.noTemplatesSubMessage' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
  />
} @else {
  <div class="table-responsive template-scroll">
    <table class="table table-hover table-centered campaign-table mb-0">
      <thead>
        <tr>
          <th>{{ "waTemplate.select.columnTemplate" | translate }}</th>
          <th>{{ "waTemplate.select.status" | translate }}</th>
          <th>{{ "waTemplate.select.category" | translate }}</th>
          <th>{{ "waTemplate.select.language" | translate }}</th>
          <th class="text-end"></th>
        </tr>
      </thead>
      <tbody>
        @for (template of templates; track template.id) {
          <tr>
            <!-- Nome em monoespaçada: é identificador técnico, não prosa — a
                 diferença entre nomes parecidos salta. O corpo vai no tooltip,
                 como na lista de templates do módulo. -->
            <td>
              <div
                class="campaign-rowmain"
                [matTooltip]="getBodyText(template)"
              >
                <b class="campaign-mono">{{ template.name }}</b>
                <span>{{ getBodyText(template) | slice: 0 : 80 }}</span>
              </div>
            </td>

            <td>
              <span
                class="campaign-badge"
                [ngClass]="statusBadgeClass(template.status)"
              >
                <span class="campaign-badge-dot" aria-hidden="true"></span>
                {{ translateTemplateStatus(template.status) }}
              </span>
            </td>

            <td>
              <span class="campaign-chip is-neutral">
                {{ translateTemplateCategory(template.category) }}
              </span>
            </td>

            <td>
              @if (languageFlag(template.language)) {
                <img
                  width="16"
                  [src]="languageFlag(template.language)"
                  [alt]="template.language"
                  [matTooltip]="template.language"
                />
              } @else {
                <span class="campaign-mono">{{ template.language }}</span>
              }
            </td>

            <td class="text-end">
              <button
                type="button"
                class="btn btn-sm"
                [ngClass]="
                  selectedTemplateId === template.id
                    ? 'btn-soft-success'
                    : 'btn-soft-primary'
                "
                [disabled]="selectedTemplateId === template.id"
                (click)="showTemplateDetails(template)"
              >
                <i class="mdi mdi-check me-1" aria-hidden="true"></i>
                {{
                  selectedTemplateId === template.id
                    ? ("waTemplate.select.selected" | translate)
                    : ("waTemplate.select.select" | translate)
                }}
              </button>
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
